/** @type {import('../help-index.js').HelpSidebarItem} */
export const TAX_IVA_DDJJ_LIQUIDACION_ITEM = {
  id: 'sub_nav_4',
  screenId: 'tax-iva-ddjj-liquidacion',
  label: 'DDJJ — Liquidación IVA',
  description: 'Calcular saldo de IVA del período y generar obligación a pagar.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Armás la liquidación mensual de IVA: débito y crédito fiscal, saldos a favor, otros ajustes y el importe a pagar o a favor. Podés confirmar y crear la obligación impositiva.',
      },
      {
        title: 'Paso 1 — Elegir período',
        fields: [
          { label: 'Mes / Año', description: 'Período fiscal a liquidar.' },
        ],
        paragraphs: ['El sistema trae totales de ventas y compras del mes.'],
      },
      {
        title: 'Paso 2 — Completar ajustes',
        fields: [
          { label: 'Saldo a favor anterior', description: 'Remanente del período previo.' },
          { label: 'Libre disponibilidad / aportes seguridad social CF', description: 'Créditos adicionales según normativa.' },
          { label: 'Otros créditos / Otros débitos', description: 'Ajustes manuales del período.' },
        ],
      },
      {
        title: 'Paso 3 — Confirmar',
        bullets: [
          'Revisá débito fiscal, crédito fiscal, saldo a pagar o a favor.',
          'Al confirmar se puede registrar una obligación en Obligaciones impositivas para pagarla desde Finanzas.',
        ],
      },
    ],
  },
}
